export const homeButtons = [
  {
    imgSrc: require("@/assets/images/icons/buttons-box/print.svg"),
    imgAlt: "Print Button",
    subtitle: "Print",
    onClick: "printMap",
  },
  {
    imgSrc: require("@/assets/images/icons/buttons-box/download.svg"),
    imgAlt: "Download Button",
    subtitle: "Download",
    onClick: "downloadMap",
  },
  {
    imgSrc: require("@/assets/images/icons/buttons-box/forward.svg"),
    imgAlt: "Forward Button",
    subtitle: "Forward",
    onClick: "showShareModal",
  },
  {
    imgSrc: require("@/assets/images/icons/buttons-box/shop.svg"),
    imgAlt: "Shop Button",
    subtitle: "Shop",
    siteLink:
      "https://shop.azcardinals.com?_s=bm-Cards-HolidayCard-DedicatedSend-2021",
  },
  {
    imgSrc: require("@/assets/images/icons/buttons-box/santa.svg"),
    imgAlt: "Extras Button",
    subtitle: "Extras",
    siteLink: "https://cardinals.rover.io/VjDX6W",
  },
];
